// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Expanded Modal Styling */
.expanded-modal {
    position: fixed;
    top: 30%;
    left: 20%;
    width: 70%;
    height: 30%;
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Align header to the top-left */
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;
  }
  
  /* Modal Content Styling */
  .modal-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  

  .metric-header-sentiment {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
    text-transform: uppercase;
    position: absolute;
    top: -170px;
    left: -547px;
  }
  /* Header Styling */
  /* .metric-header {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
    text-transform: uppercase;
    position: absolute;
    top: 7px;
    left: 20px;
  }
   */
  /* Fullscreen Value Styling */
  /* .fullscreen-value {
    text-align: center;
    font-size: 48px;
    font-weight: bold;
    color: #333;
  } */
  
   /* Separator for Expanded View 
  .fullscreen-separator {
    height: 2px;
    background-color: #c0c0c0; 
    margin: 15px 0;
    width: 100%;
  }
   */`, "",{"version":3,"sources":["webpack://./src/analytics/fullscreenHandler.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,iCAAiC;IAC1D,uBAAuB;IACvB,aAAa;IACb,sBAAsB;EACxB;;EAEA,0BAA0B;EAC1B;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;;EAGA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;EACA,mBAAmB;EACnB;;;;;;;;;IASE;EACF,6BAA6B;EAC7B;;;;;KAKG;;GAEF;;;;;;;IAOC","sourcesContent":["/* Expanded Modal Styling */\r\n.expanded-modal {\r\n    position: fixed;\r\n    top: 30%;\r\n    left: 20%;\r\n    width: 70%;\r\n    height: 30%;\r\n    background-color: white;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n    border-radius: 8px;\r\n    z-index: 1000;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start; /* Align header to the top-left */\r\n    justify-content: center;\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  /* Modal Content Styling */\r\n  .modal-content {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n  }\r\n  \r\n\r\n  .metric-header-sentiment {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    margin-bottom: 10px;\r\n    text-transform: uppercase;\r\n    position: absolute;\r\n    top: -170px;\r\n    left: -547px;\r\n  }\r\n  /* Header Styling */\r\n  /* .metric-header {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    margin-bottom: 10px;\r\n    text-transform: uppercase;\r\n    position: absolute;\r\n    top: 7px;\r\n    left: 20px;\r\n  }\r\n   */\r\n  /* Fullscreen Value Styling */\r\n  /* .fullscreen-value {\r\n    text-align: center;\r\n    font-size: 48px;\r\n    font-weight: bold;\r\n    color: #333;\r\n  } */\r\n  \r\n   /* Separator for Expanded View \r\n  .fullscreen-separator {\r\n    height: 2px;\r\n    background-color: #c0c0c0; \r\n    margin: 15px 0;\r\n    width: 100%;\r\n  }\r\n   */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
